const state = {
    screenSize: 0,
    userAgent: ""
};
const getters = {
    isSmallScreen: state => state.screenSize > 768 ? false : true,
    isMobile: state => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(state.userAgent) ? true : false
}
const actions = {
    async updateScreenSize({commit}) {
        await commit('setScreenSize', window.innerWidth)
        await commit('setUserAgent', navigator.userAgent)
    }
}
const mutations = {
    setScreenSize(state,screenSize) {
        state.screenSize = screenSize
    },
    setUserAgent(state,UA) {
        state.userAgent = UA
    }
}
export default {
    state,
    getters,
    actions,
    mutations
  };